import React from 'react';

import { EHeadingSize } from '@domain/enums/components/EHeading';

import { IntegrationsCircle } from '@profitfy/pakkun-icons';

import { useOtherGatewayIntegration } from '@helpers/hooks/pages/dashboard/integrationCenter/gateway/useOtherGatewayIntegration';
import { useTheme } from 'styled-components';

import IntegrateForm from './IntegrateForm';
import SkeletonLoading from './SkeletonLoading';

import * as S from './styles';

const Wrapper: React.FC = () => {
  const theme = useTheme();

  const { isLoadingOtherGateways, otherGateways } = useOtherGatewayIntegration();

  if (isLoadingOtherGateways || Boolean(!otherGateways)) {
    return <SkeletonLoading />;
  }

  return (
    <S.Wrapper>
      <S.HeadingWrapper>
        <IntegrationsCircle size={52} color={theme.colors.green.default} />
        <S.Heading type={EHeadingSize.H4}>Integração com Gateway Outro</S.Heading>
      </S.HeadingWrapper>

      <IntegrateForm />
    </S.Wrapper>
  );
};

export default Wrapper;
